import { userConstants } from './userConstants';

export const gtmMqttDimensions = {
  component_type: 'mqtt',
  connection: {
    attempt: {
      hash: 'e-062.010.084.000.000.267',
      eventType: 'interactions',
      dimensions: [
        ...userConstants.constans,
        'v_attempt',
        'v_date',
      ],
    },
    success: {
      hash: 'e-062.010.084.000.000.268',
      eventType: 'interactions',
      dimensions: [
        ...userConstants.constans,
        'v_host',
        'v_date',
      ],
    },
    failure: {
      hash: 'e-062.010.084.000.000.269',
      eventType: 'interactions',
      dimensions: [
        ...userConstants.constans,
        'v_host',
        'v_reason',
        'v_date',
      ],
    },
  },
  subscription: {
    attempt: {
      hash: 'e-062.167.084.000.000.271',
      eventType: 'interactions',
      dimensions: [
        ...userConstants.constans,
        'v_topic',
        'v_date',
      ],
    },
    success: {
      hash: 'e-062.167.084.000.000.272',
      eventType: 'interactions',
      dimensions: [
        ...userConstants.constans,
        'v_topic',
        'v_date',
      ],
    },
    failure: {
      hash: 'e-062.167.084.000.000.273',
      eventType: 'interactions',
      dimensions: [
        ...userConstants.constans,
        'v_topic',
        'v_date',
      ],
    },
  },
  message: {
    received: {
      hash: 'e-062.010.084.000.000.276',
      eventType: 'interactions',
      dimensions: [
        ...userConstants.constans,
        'v_topic',
        'v_payload',
        'v_date',
      ],
    },
  },
};
